// import React, { useEffect, useState } from "react";
// import { Box, Typography, Grid, Card, Container } from "@mui/material";
// import SideNav from "../../../components/sideNav";
// import BillingMetrics from "./BillingMetrics";
// import RevenueTrendsChart from "./RevenueTrendsChart";
// import CompanyBillingSummary from "./CompanyBillingSummary";
// import BillingUsage from "./BillingUsage";
// import ParentWrapper from "../../../components/ParentWrapper";
// import Header from "../../../components/header";

// function Billing() {
//   return (
//     // <Box>
//     //   <Box>
//     //     {/* <SideNav /> */}
//     //     <Box
//     //       sx={{
//     //         ml: {
//     //           xs: "0px",
//     //           md: "230px",
//     //         },
//     //       }}
//     //     >
//     //       <Box
//     //         sx={{
//     //           mb: 2,
//     //           mt: {
//     //             xs: 0,
//     //             md: 1,
//     //           },
//     //           p: 3,
//     //         }}
//     //       >
//     //         {/* Dashboard Title */}
//     //         <Typography
//     //           variant="body2"
//     //           style={{
//     //             color: "grey",
//     //           }}
//     //         >
//     //           {"Home > Billing Analytics"}
//     //         </Typography>
//     //         <Container maxWidth="xl" sx={{ mt: 4 }}>
//     //           <BillingMetrics />
//     //           <RevenueTrendsChart />
//     //           <CompanyBillingSummary />
//     //           <BillingUsage />
//     //         </Container>
//     //       </Box>
//     //     </Box>
//     //   </Box>
//     // </Box>
//     <ParentWrapper>
//          <Box
//             sx={{
//               mb: 2,
//               mt: {
//                 xs: 0,
//                 md: 1,
//               },
//               p: 3,
//             }}
//           >
//             {/* Dashboard Title */}
//             {/* <Typography
//               variant="body2"
//               style={{
//                 color: "grey",
//               }}
//             >
//               {"Home > Billing Analytics"}
//             </Typography> */}
//              <Header title={"Home > Billing Analytics"}  />
//             <Container maxWidth="xl" sx={{ mt: 4 }}>
//               <BillingMetrics />
//               <RevenueTrendsChart />
//               <CompanyBillingSummary />
//               <BillingUsage />
//             </Container>
//           </Box>
//     </ParentWrapper>
//   );
// }

// export default Billing;

import {
  Box,
  MenuItem,
  Select,
  Typography,
  useMediaQuery,
  useTheme,
  Button,
  Backdrop,
  Paper,
  styled,
  TableContainer,
  TableCell,
  TableHead,
  Table,
  TableRow,
  TableBody,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import axiosInstance from "../../../services/axiosInterceptors";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import { jwtDecode } from "jwt-decode";
import TopPerformers from "../../agent/leaderboard/TopPerformers";
import TeamRanking from "../../agent/leaderboard/TeamRanking";
import CommonFilter from "../../../components/CommonFilter";
import Loader from "../../../components/AnimatedLoader";
import Header from "../../../components/header";
import { palette, theme as colorTheme } from "../../../Convoze.theme";
import ParentWrapper from "../../../components/ParentWrapper";
import UsageTrendChart from '../../user/Billing/UsageTrendGraph'
import { useNavigate } from "react-router-dom";



const primary = colorTheme("palette", "primary").value;
const primaryBg = colorTheme("palette", "primaryBg").value;
const positive = colorTheme("palette", "positive").value;
const negative = colorTheme("palette", "negative").value;
const neutral = colorTheme("palette", "neutral").value;
const secondary = colorTheme('palette', 'secondary').value
const night = colorTheme('palette', 'night').value




const MetricCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  borderRadius: 12,
  backgroundColor: "#ffffff",
  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
  border: "1px solid #e5e7eb",
  //   height: "100%",
  //   display: "flex",
  //   flexDirection: "column",
  //   justifyContent:'space-between',
  //   gap: 5,
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
  },
}));

const MetricValue = styled(Typography)(({ theme, color }) => ({
  fontSize: "2rem",
  fontWeight: 600,
  color: color || "#374151",
  lineHeight: 1.2,
  marginBottom: theme.spacing(0.5),
  [theme.breakpoints.down("sm")]: {
    fontSize: "1.5rem",
  },
}));

const MetricLabel = styled(Typography)(({ theme }) => ({
  fontSize: "0.875rem",
  // color: "#6b7280",
  color: colorTheme('palette', 'secondary').value,
  fontWeight: 500,
}));

const MetricTitle = styled(Typography)(({ theme }) => ({
  fontSize: "0.854rem",
  color: "rgb(75 85 99 / var(--tw-text-opacity, 1))",
  fontWeight: 600,
  marginBottom: theme.spacing(1),
}));

const ChartCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: 12,
  backgroundColor: "#ffffff",
  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
  border: "1px solid #e5e7eb",
  height: 450,
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
  },
}));
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: 8,
  "& .MuiTable-root": {
    minWidth: "auto",
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "1px solid #f3f4f6",
  padding: theme.spacing(1.5),
  fontSize: "0.875rem",
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(1),
    fontSize: "0.8rem",
  },
}));

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  "& .MuiTableCell-head": {
    backgroundColor: "#f9fafb",
    fontWeight: 600,
    // color: "#374151",
    color: colorTheme('palette', 'secondary').value,
    fontSize: "0.75rem",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    borderBottom: "1px solid #e5e7eb",
  },
}));

function Billings() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [billingData, setBillingData] = useState();
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : "";

  const isFilter = { date: true, filter: false };
  const [payloadData, setPayloadData] = useState({ filters: { companyId: "", } });
  const [loading, setLoading] = useState(true);
  const [graphData, setGraphData] = useState();
  const [companyList, setCompanyList] = useState([]);
  // const [payloadData, setPayloadData] = useState({filters: {companyId: "",}});

  const navigate = useNavigate();

  const handleInvoiceClick = () => {
    navigate("/super-admin/billing/invoice"); // 👉 your invoice route
  };

  useEffect(() => {
    const fetchCompanyList = async () => {
      try {
        const res = await axiosInstance.get(apiEndPointsConfig.companyList, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const list = res?.data?.data;
        console.log(list, "list");

        // list = { "Technotask": "67e560...", "Triotech": "67e56..." }

        const formatted = Object.entries(list).map(([name, id]) => ({
          label: name,
          value: id,
        }));

        setCompanyList(formatted);
        const defaultCompany =
          formatted.find(c => c.value === "69fdafaff0596b391f8be07b") ||
          formatted[0];

        if (defaultCompany) {
          setPayloadData((prev) => ({
            ...prev,
            filters: {
              ...prev.filters,
              companyId: defaultCompany.value,
            },
          }));
        }
      } catch (err) {
        console.error("Company list error:", err);
      }
    };

    fetchCompanyList();
  }, []);

  useEffect(() => {
    if (!payloadData?.filters?.companyId) return;
    const today = new Date();
    const data = {
      startDate: payloadData?.filters?.startDate
        ? payloadData?.filters?.startDate
        : today?.toISOString().split("T")[0],
      endDate: payloadData?.filters?.endDate
        ? payloadData?.filters?.endDate
        : today?.toISOString().split("T")[0],
      companyId: payloadData?.filters?.companyId
    };
    fetchDashboardDetails(data);
  }, [payloadData]);

  const fetchDashboardDetails = async (data) => {
    setLoading(true);
    try {
      const res = await axiosInstance.post(apiEndPointsConfig?.billing, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setBillingData(res?.data?.data);
    } catch (error) {
      const statusCode = error?.response?.data?.status?.code;
      if (statusCode === 401) {
        localStorage.clear();
      } else {
        console.error("Dashboard fetch error:", error);
      }
    } finally {
      setLoading(false);
    }
  };
  const metricsData = [
    {
      title: "Total Minutes",
      value: billingData?.dashboardMatrics?.formattedMinutes || "0",
      label: (
        <Typography variant="body2" color="textSecondary">
          Out of{" "}
          <Box
            component="span"
            sx={{ color: primary, fontWeight: "600", fontSize: "1rem" }}
          >
            {billingData?.dashboardMatrics?.totalCalls}
          </Box>{" "}
          calls
        </Typography>
      ),
      // color: "#374151",
      color: secondary
    },
    {
      title: "Current Bill",
      value: billingData?.dashboardMatrics?.totalCost,
      label: "@ ₹4/minute",
      // color: "#91CC75",
      color: positive
    },
    {
      title: "Due Amount",
      value: billingData?.dashboardMatrics?.dueAmount || "0",
      label: "Pending Payment",
      // color: "#ef4444",
      color: negative
    },
    {
      title: "Next Invoice",
      value:
        shortenDateString(
          billingData?.dashboardMatrics?.nextInvoiceGeneration
        ) || "0",
      label: "Auto-generation",
      // color: "#374151",
      color: secondary
    },
  ];
  function shortenDateString(str) {
    const parts = str?.split(" "); // ["30","September","2025"]
    if (parts?.length !== 3) return str; // fallback

    const day = parts[0];
    const monthFull = parts[1];
    const year = parts[2];

    // map of months
    const months = {
      January: "Jan",
      February: "Feb",
      March: "Mar",
      April: "Apr",
      May: "May",
      June: "Jun",
      July: "Jul",
      August: "Aug",
      September: "Sep",
      October: "Oct",
      November: "Nov",
      December: "Dec",
    };

    const monthShort = months[monthFull] || monthFull;

    return `${day} ${monthShort} ${year}`;
  }

  return (
    <>
      {/* <Box
        sx={{
          ml: {
          xs: "0px",
          md: "230px",
        },
          p: 3,
          display: "flex",
          flexDirection: "column",
          gap: 2.5,
        }}
      > */}
      <ParentWrapper>


        <Box
          sx={{
            // display: "flex",
            // justifyContent: "space-between",
            // alignItems: "flex-start",
            flexDirection: isMobile ? "column" : "row",
            mb: 3,
            gap: 2,
          }}
        >
          <Box>
            {/* <Typography
              variant="h5"
              sx={{
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                fontWeight: 700,
              }}
              gutterBottom
            >
              Billing Dashboard
            </Typography> */}

            {/* <Typography
              variant="h5"
              sx={{
                fontWeight: 500,
                // color: "#424242",
                color : secondary
              }}
            >
              {"Billing Dashboard"}
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              Monitor your AI Speech Analytics usage and billing
            </Typography> */}
            {/* <Header title={"Billing Dashboard"} subHeading={"Monitor your AI Speech Analytics usage and billing"} /> */}
          </Box>

          <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
            // backgroundColor: "blue",
          }}>

            <Box>
              <Button
                onClick={handleInvoiceClick}
                // variant="button"
                sx={{
                  height: 40,
                  px: 2.5,
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "15px",
                  borderRadius: "10px",
                  backgroundColor: "#E0E7FF",
                  // border: "2px solid #4F46E5",
                  // color: "#4F46E5",
                  // backgroundColor: "#EEF2FF",
                  "&:hover": {
                    backgroundColor: "#E0E7FF",
                    // boxShadow: "0px 0px 0px 3px rgba(79,70,229,0.15)",
                  },
                }}
              >
                Generate Invoice
              </Button>

            </Box>
            <Box sx={{ display: 'flex', }}>
              <Box sx={{
                minWidth: 250, borderRadius: "15px",
                textTransform: "none",
                // border: `2px solid  ${primaryBg}`,
                color: "#1E293B",
                // bgcolor: "#E6F0FF",
                // boxShadow: "0px 1px 1px 0px #D2D2D2",
                fontWeight: 500,
                fontSize: "14px",
                transition: "background-color 0.2s, box-shadow 0.2s",
                "& .MuiOutlinedInput-root": {
                  height: 40, // 👈 control height
                  borderRadius: "10px",
                },
                "&:hover": {
                  backgroundColor: "#EEF2FF",
                  boxShadow: "0px 1px 4px rgba(0,0,0,0.1)",
                },
                "&:active": {
                  // boxShadow: "inset 0 2px 4px rgba(0,0,0,0.2)",
                  backgroundColor: "#E6F0FF",
                }
              }}>
                <TextField
                  fullWidth
                  select
                  // label="Select Company"
                  value={payloadData?.filters?.companyId || ""}
                  onChange={(e) =>
                    setPayloadData((prev) => ({
                      ...prev,
                      filters: {
                        ...prev?.filters,
                        companyId: e.target.value,
                      },
                    }))
                  }
                >
                  {companyList.map((c) => (
                    <MenuItem key={c.value} value={c.value}>
                      {c.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
              <CommonFilter
                setPayloadData={(newFilterData) =>
                  setPayloadData((prev) => ({
                    ...newFilterData,
                    filters: {
                      ...newFilterData.filters,
                      companyId: prev?.filters?.companyId,
                    },
                  }))
                }
                storageName={"managerBilling"}
                isFilter={isFilter}
              />
            </Box>
          </Box>
        </Box>
        {loading ? (
          <Loader />
        ) : (
          <>
            {/* Metrics Cards */}
            <Grid container spacing={3} sx={{ mb: 4 }}>
              {metricsData?.map((metric, index) => (
                <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={index}>
                  <MetricCard elevation={0}>
                    <MetricTitle font={metric?.title == "Next Invoice"}>
                      {metric.title}
                    </MetricTitle>
                    <MetricValue color={metric.color}>
                      {metric.value}
                    </MetricValue>
                    <MetricLabel>{metric.label}</MetricLabel>
                  </MetricCard>
                </Grid>
              ))}
            </Grid>
            <Grid container spacing={3}>
              {/* Usage Trend Chart */}
              <Grid item size={{ xs: 12, md: 12 }}>
                <ChartCard elevation={0}>
                  <UsageTrendChart
                    title={"Usage Trend"}
                    trendData={billingData?.usageTrendGraph}
                    setGraphData={setGraphData}
                  />
                </ChartCard>
              </Grid>
              {/* Agent Call Usage - hidden */}
              {/* <Grid item size={{ xs: 12, md: 4 }}>
                <ChartCard elevation={0}>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography
                      variant="h6"
                      component="h2"
                      fontWeight="600"
                      color="#374151"
                      gutterBottom
                      sx={{ mb: 3 }}
                    >
                      Agent Call Usage
                    </Typography>
                    <Box
                      sx={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        backgroundColor: primary,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography fontWeight="600" color="#FFF">
                        {billingData?.costPerAgent?.length || 0}
                      </Typography>
                    </Box>
                  </Box>
                  <StyledTableContainer
                    sx={{
                      maxHeight: 400,
                      overflowY: "auto",
                      "&::-webkit-scrollbar": {
                        width: "3px",
                        height: "3px",
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: "#f1f1f1",
                        borderRadius: "10px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: secondary,
                        borderRadius: "10px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: secondary
                      },
                    }}
                  >
                    <Table stickyHeader size="small">
                      <StyledTableHead>
                        <TableRow>
                          <StyledTableCell> AGENT NAME</StyledTableCell>
                          <StyledTableCell>Calls</StyledTableCell>
                          <StyledTableCell>DURATION</StyledTableCell>
                          <StyledTableCell>COST</StyledTableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {billingData?.costPerAgent?.length > 0 ? (
                          billingData?.costPerAgent?.map((call, index) => (
                            <TableRow key={index}>
                              <StyledTableCell>
                                <Typography variant="body2" fontWeight="600" color="#374151">
                                  {call?.agentFullName}
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell>
                                <Typography variant="body2" color={neutral} fontWeight="600">
                                  {call?.totalCalls}
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell>
                                <Typography variant="body2" color={neutral} fontWeight="600">
                                  {call?.totalMinutes}
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell>
                                <Typography variant="body2" fontWeight="600" color={negative}>
                                  {call?.totalCost}
                                </Typography>
                              </StyledTableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={4} align="center" sx={{ padding: 16.3 }}>
                              <Typography variant="body2" fontWeight="600" color={secondary}>
                                No Data
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </StyledTableContainer>
                </ChartCard>
              </Grid> */}
            </Grid>
          </>
        )}

      </ParentWrapper>
    </>
  );
}

export default Billings;
